import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { ChevronRight } from "lucide-react";
import { Link, useLocation } from "react-router";
import { useState } from "react";

import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card";
import { SidebarItemWithItems } from "../../sidebar/utils/sidebarLinks";
import { isRouteActive } from "../../sidebar/utils/isRouteActive";

function CollapsibleItem({
  item,
  open,
}: {
  item: SidebarItemWithItems;
  open: boolean;
}) {
  const [isHovered, setIsHovered] = useState(false);
  const location = useLocation();

  const isActive =
    isHovered ||
    item.items.some((subItem) => isRouteActive(location.pathname, subItem.url));

  const iconClassName = `w-4 h-4 ${isActive ? "text-brand-primary" : ""}`;

  return (
    <Collapsible asChild defaultOpen={isActive} className="group/collapsible">
      <div>
        <CollapsibleTrigger asChild>
          {!open ? (
            <HoverCard openDelay={150} closeDelay={150}>
              <HoverCardTrigger asChild>
                <Link to={item.items[0].url}>
                  <div
                    className={`${
                      isActive ? "text-brand-primary" : ""
                    } flex items-center gap-2 py-2 text-sm`}
                  >
                    {item.icon && <item.icon className={iconClassName} />}

                    <span>{item.title}</span>

                    <ChevronRight className="ml-auto transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
                  </div>
                </Link>
              </HoverCardTrigger>
              <HoverCardContent
                side="right"
                align="start"
                className="p-0 w-fit ml-2"
              >
                <div className="flex flex-col divide-y divide-border w-full">
                  <p className="px-4 py-2 break-words">
                    <strong>{item.title}</strong>
                  </p>
                  {item.items?.map((subItem) => (
                    <Link
                      to={subItem.url}
                      className="px-4 py-2 cursor-pointer hover:bg-background-200 break-words max-w-40"
                      key={subItem.url}
                      onMouseEnter={() => setIsHovered(true)}
                      onMouseLeave={() => setIsHovered(false)}
                    >
                      {subItem.title}
                    </Link>
                  ))}
                </div>
              </HoverCardContent>
            </HoverCard>
          ) : (
            <div
              className={`${
                isActive ? "text-brand-primary" : ""
              } flex items-center gap-2 py-2 text-sm`}
            >
              {item.icon && <item.icon className={iconClassName} />}
              <div className="min-w-24 truncate">
                <span>{item.title}</span>
              </div>
              <ChevronRight className="ml-auto transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
            </div>
          )}
        </CollapsibleTrigger>
        <CollapsibleContent>
          <div className="pl-4 border-l-4 border-border flex flex-col">
            {item.items?.map((subItem) => (
              <Link
                to={subItem.url}
                key={subItem.url}
                className="py-2 border-b border-border last:border-none text-sm"
              >
                <span>{subItem.title}</span>
              </Link>
            ))}
          </div>
        </CollapsibleContent>
      </div>
    </Collapsible>
  );
}

export default CollapsibleItem;
